import { create } from 'zustand';
import { updateWaterTariff } from '../../../api/api';
import { toast } from 'react-toastify';

const isValid = (v) => v !== undefined && v !== null && v !== '';

export const useWaterTariffStore = create((set, get) => ({
  tariff: null,
  setTariff: (tariff) => set(() => ({ tariff })),

  updateWaterTariffs: async (device_id) => {
    const { tariff } = get();

    if (tariff) {
      const { consumption_tariff, disposal_tariff } = tariff ?? {};
      const body = { device_id, ...(isValid(consumption_tariff) ? { consumption_tariff } : {}), ...(isValid(disposal_tariff) ? { disposal_tariff } : {}) };

      if (isValid(consumption_tariff) || isValid(disposal_tariff)) {
        await updateWaterTariff(body, function (err) {
          if (err?.error) {
            toast.error(err.error, { hideProgressBar: true });
          }
        });
      }
    }
  },
}));
